import { BrowserRouter, Link, NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { SetupPage } from './pages/SetupPage'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ContentPage } from './pages/ContentPage'
import { SocialAccountsPage } from './pages/SocialAccountsPage'
import { MediaPage } from './pages/MediaPage'
import { SecurityPage } from './pages/SecurityPage'
import './App.css'

function AppShell() {
  const { status, user, logout } = useAuth()

  if (status === 'loading') {
    return <main className="page"><p aria-live="polite">Laddar…</p></main>
  }

  if (status === 'needs-setup') {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<SetupPage />} />
        </Routes>
      </BrowserRouter>
    )
  }

  if (status === 'unauthenticated' || !user) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter>
      <a href="#main" className="skip-link">Hoppa till innehåll</a>
      <header className="topbar" role="banner">
        <Link to="/" className="brand">Social Agent</Link>
        <nav aria-label="Huvudmeny">
          <NavLink to="/" end>Översikt</NavLink>
          <NavLink to="/content">Innehåll</NavLink>
          <NavLink to="/media">Media</NavLink>
          <NavLink to="/settings/social-accounts">Konton</NavLink>
          <NavLink to="/settings/security">Säkerhet</NavLink>
        </nav>
        <div className="topbar-user">
          <span className="muted small">{user.email}</span>
          <button type="button" className="link" onClick={() => void logout()}>Logga ut</button>
        </div>
      </header>

      <div id="main">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/content" element={<ContentPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/settings/social-accounts" element={<SocialAccountsPage />} />
          <Route path="/settings/security" element={<SecurityPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  )
}

export default App
